export var MarSecLevelContent;
(function (MarSecLevelContent) {
    MarSecLevelContent["One"] = "1";
    MarSecLevelContent["Two"] = "2";
    MarSecLevelContent["Three"] = "3";
})(MarSecLevelContent || (MarSecLevelContent = {}));
export const marSecLevelContentOptions = [
    { value: MarSecLevelContent.One, text: '1' },
    { value: MarSecLevelContent.Two, text: '2' },
    { value: MarSecLevelContent.Three, text: '3' },
];
//# sourceMappingURL=MarSecLevelContent.js.map